import ReactDOM from 'react-dom';
import log from 'loglevel';
import './index.scss';
import { Theming } from './common/Theming';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Config from "./common/Config";
import AppService from "./common/AppService";
import SiteAuth from "./common/SiteAuth";

// Enable logging but do not persist.
log.enableAll(false);

const appName = import.meta.env.VITE_APP_NAME;
const appVersion = import.meta.env.VITE_APP_VERSION;

log.info("STARTING: " + appName + ': ' + appVersion );

// Manage unhandled rejections.
// @see https://javascript.info/promise-error-handling
window.addEventListener('unhandledrejection', function(event) {
  // the event object has two special properties:
  // event.promise [object Promise] - the promise that generated the error
  // event.reason Error: Whoops! - the unhandled error object
  log.warn("Unhandled promise rejection", event.reason);
  if (event.reason.errorMessage !== 'No active window to close!')
    alert("ERROR: " + event.reason);
});

Config.init();

initApp();

// init app
async function initApp(): Promise<void> {
  // Basic init.
  const initialized = await AppService.init();
  // Handle the authorization callback even if basic init failed: with login
  // required and no session yet, AppService.init fails (the city fetch has no
  // auth data) precisely when the OAuth code is in the URL waiting to be
  // exchanged, and skipping SiteAuth.init here would make login impossible.
  const proceed = await SiteAuth.init();
  // Full initialization.
  const success = initialized && proceed && await AppService.initAll();

  if (success) {
    log.info("App initialization completed. Rendering...");
  }
  else {
    log.info("App initialization stopped. May be redirecting...");
  }

  ReactDOM.render(<Theming />, document.getElementById('app'));
}

// SW successful registration.
function registrationSuccessful(): void {
  log.info("SW registration successful, version", appVersion);
}

// SW Update if new version found.
function updateServiceWorker(registration: ServiceWorkerRegistration): void {
  log.info("SW update, version", appVersion);
  const registrationWaiting = registration.waiting;
  if (registrationWaiting) {
    registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
    registrationWaiting.addEventListener('statechange', e => {
      if ((e.target as ServiceWorker).state === 'activated') {
        window.location.reload();
      }
    });
  }
}

// SW Prompt user, new version detected
function promptUserToRefresh(registration: ServiceWorkerRegistration): void {
  // Either confirm or just inform and go for it.
  /*
  if (window.confirm("New version available! OK to refresh?")) {
    registration.waiting.postMessage({type: 'SKIP_WAITING'});
  }
  */
  window.alert("Actualizando " + appName + " version " + appVersion);
  // registration.waiting.postMessage({type: 'SKIP_WAITING'});
  updateServiceWorker(registration);
}


// Register Sevice Worker.
// Learn more about service workers: https://bit.ly/CRA-PWA
const swConfig = {
  // registrationSuccessful no usa el registro: solo escribe la version.
  onSuccess: () =>  { registrationSuccessful() },
  onUpdate: (registration: ServiceWorkerRegistration) => { promptUserToRefresh(registration) },
};

serviceWorkerRegistration.register(swConfig);

// Vuelta a primer plano: es el equivalente en PWA a reabrir la app, y el unico
// momento en que se puede detectar un despliegue sin recargar la pagina.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    serviceWorkerRegistration.checkForUpdates();
  }
});
